import { render, staticRenderFns } from "./mypolicy.vue?vue&type=template&id=415192c4&scoped=true"
import script from "./mypolicy.vue?vue&type=script&lang=js"
export * from "./mypolicy.vue?vue&type=script&lang=js"
import style0 from "./mypolicy.vue?vue&type=style&index=0&id=415192c4&prod&lang=scss&scoped=true"
import style1 from "./mypolicy.vue?vue&type=style&index=1&id=415192c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415192c4",
  null
  
)

export default component.exports